import logo from './logo.png';
import rdkl_logo from './rdkl_logo.png';

import React, { useState, useEffect } from 'react';

import { OAUTH_URI } from './config/constants';

import axios from "axios"

const App = () => {

    const userClientId = localStorage.getItem('userClientId') || crypto.randomUUID();
    localStorage.setItem('userClientId', userClientId);
  
    // Security Pre-Processing********************************************************************
    
    var screenSize = {};
    var deviceInfo = {};
    
    // Use Effect *****************************************************************************
    useEffect(() => {
      console.log("*** app.radikle UseEffect - getting client data ***"); 
  
      const fetchData = async () => {
        try {
          await getAndStoreClientData();
          await createUserClientSession();
        }  
        catch (err) {
          console.log(err); // Handle error if any async call fails
        }
        finally {
          console.log("*** app.relishious UseEffect Completed ***"); 
        }
      }
  
      fetchData();
  
    }, []);   // Empty Dependency Array - 
              // Executed only once when the page launches but not on every re-render
    
    async function getAndStoreClientData() {
      if(sessionStorage.getItem("User-Client-Data") != null) {
        console.log("INFO: User Client Data is already obtained.");
      }
      else {      
        console.log("INFO: Getting ScreenAndDeviceInfo");
        await getScreenAndDeviceInfo();
  
  
        let data = {
          'clientID': "relishious",
          'userClient' : {
            'userClientID': userClientId,
            'userAgent': deviceInfo.userAgent,
          },
          'screenInfo': screenSize,
          'deviceInfo': deviceInfo,
        };
  
        sessionStorage.setItem("User-Client-Data", JSON.stringify(data));
        console.log("INFO: ScreenAndDeviceInfo and ClientIPInfo obtained and stored in Session.");
      }
    }
  
    async function createUserClientSession() {
      if(!clientSessionRequested) {
        setClientSessionRequested(true);
        await createClientSession();
      }
    }
  
    const [clientSessionRequested, setClientSessionRequested] = useState(false);
  
    //********************************************************************************/
    /* A client session needs to be established first before proceeding with any further
       dialog with the server */
    async function createClientSession() {
      var data = JSON.parse(sessionStorage.getItem("User-Client-Data"));
      var clientSessionID = sessionStorage.getItem("User-Client-Session-ID");
      if(clientSessionID != null) {
        console.log("INFO: A client session already exists. Hence a new session need not be created.");
        return;
      }
      await axios.post(OAUTH_URI + "/user-client-data", data, { withCredentials: true })
        .then((response) => {
          if (response.status === 200) {
            let sessionID = response.data;
            sessionStorage.setItem("User-Client-Session-ID", sessionID);
            console.log("INFo: A Client Session with ID is obtained and stored in Session.");
          }
        }).catch((error) => {
          console.log("Error: While obtaining Client Session with ID");
          console.log(error.message);
        });
    }

    
  async function getScreenAndDeviceInfo() {
    // Screen information
    screenSize = {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio
    };

    // Other device-related information
    deviceInfo = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.hardwareConcurrencyplatform,
      cookiesEnabled: navigator.cookieEnabled,
      concurrency: navigator.hardwareConcurrency,
      online: navigator.onLine
    };

    console.log('INFO: Screen Information and Device Information obtained');
  }

  return (
    <div
      className="h-screen w-full bg-cover bg-center flex flex-col items-center justify-center"
      style={{
        backgroundImage: `url("/relishious.webp")`, // path relative to public/
      }}
    >
      <div className="absolute inset-0 bg-black/40 z-0"></div>

      <div className="relative z-10 flex justify-center items-center h-full">
        <div className="flex flex-col space-y-2">
          <div className="flex flex-row items-center space-x-6 bg-black/20 px-6 py-4 rounded-xl shadow-lg">
            {/* Logo on the left */}
            <img
              src={logo}
              alt="Logo"
              className="h-20 w-auto bg-black/60 p-2 rounded-xl shadow"
            />

            {/* Heading text on the right */}
            <h1 className="text-4xl font-bold text-orange-400">
              RELISHIOUS
            </h1>
            
          </div>
          <p className="text-lg text-orange-300 pl-40 bg-black/20">
            Savor the Flavor! 
          </p>
          <p className="text-lg text-orange-300 pl-40 bg-black/20">
            Coming soon ....
          </p>
        </div>
      </div>

      {/* Copyright in bottom left */}
      <div className="absolute bottom-4 left-4 z-10 text-sm text-orange-300 bg-black/30 px-2 py-1 rounded">
        <div>
          Copyright © 2025 Relishious Ltd.
        </div> 
        <div>
          All Rights Reserved.
        </div>
      </div>

      {/* Bottom right with logo between "Powered by" and "Your Name" */}
      <div className="absolute bottom-1 right-4 z-10 flex items-center space-x-0 text-sm text-green-300 bg-black/30 px-2 py-1 rounded">
        <div>Powered by</div>
      
        {/* Logo in between */}
        <img
          src={rdkl_logo}
          alt="Logo"
          className="h-12 w-auto rounded-xl shadow-md"
        />

        <div><a href="https://app.radikle.com" target="_blank" rel="noopener noreferrer">Radikle AI</a></div>
      </div>


    </div>
  );
};

export default App;
